
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Subscription } from "@/types/subscription";
import { processSubscriptionData } from "@/utils/subscriptionDataUtils";

/**
 * Fetches subscription status with stored usage values.
 */
export const useSubscriptionStatus = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['subscription-status', userId],
    queryFn: async () => {
      if (!userId) throw new Error("No user ID");

      // Fetch subscription
      const { data: subscription, error } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', userId)
        .single();

      if (error && error.message !== 'The result contains 0 rows') {
        throw new Error(`Failed to fetch subscription: ${error.message}`);
      }

      // If no subscription found, return empty object
      if (!subscription) {
        return {} as Subscription;
      }

      // Use the subscription data directly with stored company_resolutions_used
      return processSubscriptionData(subscription);
    },
    enabled: !!userId,
    staleTime: 60000,
    retry: 1,
  });
};
